import {useContext} from 'react';
import {AppContext} from "../../../../context/AppContext";
import Button from "../../../elements/Button/Button";
import clsx from "clsx";
import styles from './SubmitController.module.scss'
import * as ACTIONS from "../../../../store/actions/invoicesActions";
import {useDispatch, useSelector} from "react-redux";
import dayjs from "dayjs";
import {setErrors} from "../../../../store/actions/errorsActions";
import {fetchInvoice} from "../../../../store/actions/invoicesActions";

const SubmitController = ({formState, setFormState}) => {
    const dispatch = useDispatch();
    const {customer} = useSelector((state) => state.customer);
    const {profile} = useSelector((state) => state.profile);
    const {isInvoiceEdited, setIsFormOpen} = useContext(AppContext);

    const restoreToInitial = () => {
        dispatch(setErrors('invoice', "", []));
        setFormState({
            number: "",
            customer: {name: "", email: "", address: {street: ""}},
            sender: {name: "", email: "", address: {street: ""}},
            billingInfo: {bicCode: "", iban: "", beneficiaryBank: "", bankAddress: "", taxNumber: ""},
            dueDate: "",
            total: 0,
            items: [],
        });
    }

    const handleSubmit = async (event, type) => {
        event.preventDefault();

        const errors = [];

        if (!formState.number) {
            errors.push({err: 'idenNumber', msg: "Field is empty"});
        }

        if (!formState.billingInfo?.bicCode) {
            errors.push({err: 'bicCode', msg: "Field is empty"});
        }

        if (!formState.billingInfo?.beneficiaryBank) {
            errors.push({err: 'beneficiaryBank', msg: "Field is empty"});
        }

        if (!formState.billingInfo?.bankAddress) {
            errors.push({err: 'bankAddress', msg: "Field is empty"});
        }

        if (!formState.billingInfo?.iban) {
            errors.push({err: 'iban', msg: "Field is empty"});
        }

        if (!formState.dueDate) {
            errors.push({err: 'paymentDue', msg: "Field is empty"});
        }
        if (!formState.items || formState.items.length === 0) {
            errors.push({err: 'items', msg: "An item must be added."});
        } else {
            formState.items.map((item) => {
                if (!item.name) errors.push({err: 'items', msg: "Item name can't be empty"});
                if (!item.quantity) errors.push({err: 'items', msg: "Item quantity can't be empty"});
                if (!item.price) errors.push({err: 'items', msg: "Item price can't be empty"});
            });
        }

        if (!customer || !customer.length || !customer[0]) {
            console.error("Error: customer data is missing or not available.");
            dispatch(setErrors('invoice', "missing_customer", ["Customer data is required."]));
            return;
        }

        const fullInvoice = {
            ...formState,
            date: dayjs(formState.date).format(),
            createdAt: dayjs().format(),
            userId: profile.id,
            sender: {
                ...formState.sender,
                name: profile.name,
                surname: profile.surname,
                name_ukr: profile.name_ukr,
                surname_ukr: profile.surname_ukr,
                taxNumber: profile.taxNumber,
            },
            customer: {
                name: customer[0].name,
                name_ukr: customer[0].name_ukr,
                surname: customer[0].surname,
                surname_ukr: customer[0].surname_ukr,
                email: customer[0].email,
                address: {
                    street: customer[0].address.street,
                    city: customer[0].address.city,
                    district: customer[0].address.district,
                    region: customer[0].address.region,
                    zip: customer[0].address.zip,
                },
                address_ukr: {
                    street_ukr: customer[0].address_ukr.street_ukr,
                    city_ukr: customer[0].address_ukr.city_ukr,
                    district_ukr: customer[0].address_ukr.district_ukr,
                    region_ukr: customer[0].address_ukr.region_ukr,
                }
            },
            total: formState.total,
            items: formState.items.map((item) => ({
                ...item,
                price: Number(item.price),
                quantity: Number(item.quantity),
                total: Number(item.total),
            })),
            isDraft: true,
        }

        try {
            dispatch(setErrors('invoice', 'invoice', errors));
            if (type === 'add' && errors.length === 0) {
                dispatch(ACTIONS.createInvoice(fullInvoice));
                restoreToInitial();
                setIsFormOpen(false);
            } else if (type === 'save') {
                const draftInvoice = {
                    ...fullInvoice,
                    isDraft: true,
                }
                dispatch(ACTIONS.saveAsDraft(draftInvoice));
                restoreToInitial();
                setIsFormOpen(false);
            } else if (type === 'change' && errors.length === 0) {
                console.log('fullInvoice:', fullInvoice);
                dispatch(ACTIONS.updateInvoice(fullInvoice));
                restoreToInitial();
                setIsFormOpen(false);
                dispatch(fetchInvoice(fullInvoice.id));
            }
        } catch (error) {
            console.error("Error submitting invoice:", error);
            dispatch(setErrors('invoice', "save_invoice", ["An error occurred while saving the invoice."]));
        }
    };

    const discard = () => {
        setIsFormOpen(false);
        if (!isInvoiceEdited) restoreToInitial();
    };

    return (
        <div className={clsx(styles.controller, {
            [styles.edited]: isInvoiceEdited,
        })}>
            <Button className={clsx('tertiary', 'small', styles.discardButton)} type="button" onClick={discard}>
                Discard
            </Button>
            <Button
                type="submit"
                className='secondary small'
                onClick={(event) => handleSubmit(event, 'save')}
            >
                Save as Draft
            </Button>
            <Button
                type="button"
                className='primary small'
                onClick={(event) =>
                    handleSubmit(event, 'add')
                }
            >
                Save & Send
            </Button>
        </div>
    );
};

export default SubmitController;
